module.exports = __webpack_public_path__ + "static/media/circle.76e33771.svg";